<template>
  <v-row no-gutters>
    <template v-if="eType==='LIGHT'">
      <v-col class="pl-1 pr-2">
        <OperatorSelector v-model="op" />
      </v-col>
      <v-col>
        <v-text-field filled v-model="eValue" :hide-details="hideDetails" :rules="rulesThreshold" :label="$t('unit.%')"></v-text-field>
      </v-col>
    </template>
    <template v-else-if="eType==='BUTTON'">
      <!-- <v-col class="pl-1 pr-2">
        <OperatorSelector v-model="op" :avilableOpList="[5]" />
      </v-col> -->
      <v-col cols="6" offset="6" class="pl-1">
        <v-select filled v-model="eValue" :items="buttonItems" 
        :hide-details="hideDetails" single-line :label="$t('type.BUTTON')"></v-select>
      </v-col>
    </template>
    <template v-else>
      <v-col class="pl-1 pr-2">
        <OperatorSelector v-model="op" />
      </v-col>
      <v-col>
        <v-text-field filled v-model="eValue" :hide-details="hideDetails" :rules="rulesThreshold" :label="$t('selector.threshold')"></v-text-field>
      </v-col>
    </template>
  </v-row>
</template>
<script>
import OperatorSelector from '@/components/utils/select/OperatorSelector'
export default {
  name: 'TriggerEndpointValueSelector',
  components: {
    OperatorSelector
  },
  props: {
    value: {
      type: Object
    },
    'hideDetails': {
      type: Boolean,
      default: true
    },
    eType: {
      type: String
    },
    eId: {
      type: String
    }
  },
  data() {
    return {
      idToEventType: {
        'external-light-1': 'brightness',
        'onboard-sensor-temperature': 'temperature',
        'onboard-sensor-humidity': 'humidity',
        'onboard-sensor-illumination': 'illumination',
        'onboard-air-sensor-co2': 'co2',
        'onboard-air-sensor-co': 'co',
        'onboard-air-sensor-voc': 'voc',
        'onboard-sensor-motion': 'motion',
        'onboard-sensor-smoke': 'smoke',
        'smart-button-3': 'clickState'
      },
      rulesThreshold: [
        v => (parseInt(v) >= 0 && parseInt(v) <= 100) || this.$t('configurations.threadhold_between', {
          from: 0,
          to: 100
        })
      ],
      buttonItems: [{
        text: this.$t('button.SINGLE'),
        value: 1
      }, {
        text: this.$t('button.DOUBLE'),
        value: 2
      }, {
        text: this.$t('button.TRIPLE'),
        value: 3
      }, {
        text: this.$t('button.LONG'),
        value: 4
      }],
      op: (this.value || {}).op || 1,
      eValue: (this.value || {}).value || 1,
      eventType: (this.value || {}).eventType
    }
  },
  watch: {
    op() {
      return this.$emit('input', {op: this.op, value: this.eValue, eventType: this.eventType});
    },
    eValue() {
      return this.$emit('input', {op: this.op, value: this.eValue, eventType: this.eventType});
    }
  },
  mounted() {
    this.eventType = this.idToEventType[this.eId];
    this.$emit('input', {op: this.op, value: this.eValue, eventType: this.eventType});
  }
}
</script>